import AdminTicket from '../../pages/admin/admin-ticket/admin-ticket'

export default AdminTicket
